module.exports = __webpack_public_path__ + "img/ServiceIt.9e41f1e0.png";